import React from "react";
import "./Crypto.css";
import CryptoDashboard from "../../assests/crypto_dashboard.png";
import PhoneMockup from "../PhoneMockup/PhoneMockup";

const ASSET_BASE = "http://api.sendcheap.us/public/assets";

const coins = [
  { symbol: "BTC", name: "Bitcoin" },
  { symbol: "ETH", name: "Ethereum" },
  { symbol: "USDT", name: "Tether" },
  { symbol: "SOL", name: "Solana" },
  { symbol: "BNB", name: "BNB Chain" },
  { symbol: "USDC", name: "USD Coin" },
];

const Crypto = () => {
  return (
    <section className="crypto-section">
      <div className="crypto-inner">
        {/* Left */}
        <div className="crypto-left">
          <div className="crypto-label">Crypto</div>
          <h2 className="crypto-title">
            Sell your crypto.<br />
            <span className="crypto-accent">Get naira instantly.</span>
          </h2>
          <p className="crypto-desc">
            We buy your crypto at competitive rates — no middlemen, no delays.
            Convert to naira in seconds and withdraw to any Nigerian bank.
          </p>

          <div className="crypto-table">
            {coins.map((c, i) => (
              <div className="crypto-row" key={i}>
                <img
                  src={`${ASSET_BASE}/${c.symbol.toLowerCase()}.png`}
                  alt={c.symbol}
                  className="cr-coin-img"
                />
                <div className="cr-meta">
                  <span className="cr-symbol">{c.symbol}</span>
                  <span className="cr-name">{c.name}</span>
                </div>
                <span className="cr-arrow">→ &#8358;</span>
              </div>
            ))}
            <div className="crypto-more">+ Many more supported</div>
          </div>

          <a href="https://onelink.to/n9hyxn" target="_blank" rel="noreferrer">
            <button className="crypto-btn">Sell Crypto Now &rarr;</button>
          </a>
        </div>

        {/* Right — phone mockup with real screenshot */}
        <div className="crypto-right">
          <PhoneMockup
            screenshot={CryptoDashboard}
            alt="Crypto dashboard"
            size="lg"
            glow={true}
            className="crypto-pm"
          />

          {/* Live rates floating card */}
          <div className="crypto-rates-card">
            <div className="crc-header">Live Rates</div>
            {coins.slice(0, 3).map((c, i) => (
              <div
                className="crc-row"
                key={i}
                style={{ borderBottom: i < 2 ? "1px solid #f4f4f5" : "none" }}
              >
                <img
                  src={`${ASSET_BASE}/${c.symbol.toLowerCase()}.png`}
                  alt={c.symbol}
                  className="crc-coin-img"
                />
                <span className="crc-sym">{c.symbol}</span>
                <span className="crc-sep">→</span>
                <span className="crc-val">
                  {c.symbol === "BTC" && "₦98.2M"}
                  {c.symbol === "ETH" && "₦5.6M"}
                  {c.symbol === "USDT" && "₦1,640"}
                </span>
              </div>
            ))}
            <div className="crc-footer">Updates every minute</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Crypto;
